export default "__VITE_PUBLIC_ASSET__b675e977__"